// src/lib/i18n.js
import en from '../locales/en/translation.json';
import fa from '../locales/fa/translation.json';

export const MESSAGES = { en, fa };

export const LANGUAGES = [
    { code: 'fa', label: 'Persian', nativeLabel: 'فارسی', dir: 'rtl' },

    { code: 'en', label: 'English', nativeLabel: 'English', dir: 'ltr' },
];

export const getLocale = (dir) => (dir === 'rtl' ? 'fa' : 'en');
export const getDirection = (locale) => (locale === 'fa' ? 'rtl' : 'ltr');